export default __webpack_public_path__ + "static/media/change-password.42d08b11.svg";